export default "__VITE_ASSET__DZ6U8yfT__"